export interface UploadedFile {
  id: string;
  url: string;
  mime: string;
  name: string;
}

export const filetypes = [
  'jpg',
  'jpeg',
  'png',
  'avif',
  'svg',
  'gif',
  'bmp',
  'webp',
  'avi',
  'mp4',
  'mpeg',
  'mp3',
  'wav',
  'csv',
  'txt',
  'doc',
  'rtf',
  'json',
  'docx',
  'pdf',
  'rar',
  'zip',
  'xls',
  'xlsx',
] as const;

export type Filetype = (typeof filetypes)[number];
